import {Injectable} from '@angular/core';

@Injectable()
export class ConstantsService {
    // // static readonly oauthUrl          = 'http://auth-maxtvm.requestumdemo.com';
    // // static readonly domainBD          = 'http://building-maxtvmedia.requestumdemo.com/api';
    // // static readonly domainParcels     = 'http://parcels-maxtvmedia.requestumdemo.com/api';
    // // static readonly domainEmails      = 'http://email-maxtvmedia.requestumdemo.com/api';

    // // DEV
    // static readonly oauthUrl = 'https://auth.maxtvcommunications.com';
    // static readonly domainBD = 'https://building.maxtvcommunications.com/api';
    // static readonly domainParcels = 'https://parcels.maxtvcommunications.com/api';
    // static readonly domainEmails = 'https://mail.maxtvcommunications.com';
    // static readonly domainDocuments = 'https://documents.maxtvcommunications.com';
    // static readonly domainIncidentReports = 'https://incedent-reports.maxtvcommunications.com/api';
    // static readonly domainKeyLog          = 'https://key-log.maxtvcommunications.com/api';
    // static readonly domainServiceRequest  = 'https://service-request.maxtvcommunications.com/api';
    // static readonly domainPassOnLog       = 'https://pass-on-log.maxtvcommunications.com/api';
    // static readonly domainDailyReports    = 'https://daily-reports.maxtvcommunications.com/api';
    // static readonly domainNpmiLink    = 'https://auth.maxtvcommunications.com/api';
    // static readonly domainAmenities = 'https://amenity.maxtvcommunications.com/api';
    // static readonly domainParkingPass = 'https://parking-pass.maxtvcommunications.com/api';

    // // PROD
    // // static readonly oauthUrl = 'https://blue-auth.maxcondoclub.com';
    // // static readonly domainBD = 'https://blue-building.maxcondoclub.com/api';
    // // static readonly domainParcels = 'https://blue-parcels.maxcondoclub.com/api';
    // // static readonly domainEmails = 'https://blue-email-merge.maxcondoclub.com';
    // // static readonly domainDocuments = 'https://blue-documents.maxcondoclub.com';
    // // static readonly domainIncidentReports = 'https://blue-incedent-reports.maxcondoclub.com/api';
    // // static readonly domainKeyLog = 'https://blue-key-log.maxcondoclub.com/api';
    // // static readonly domainServiceRequest = 'https://blue-service-request.maxcondoclub.com/api';
    // // static readonly domainPassOnLog = 'https://blue-pass-on-log.maxcondoclub.com/api';
    // // static readonly domainDailyReports = 'https://blue-daily-reports.maxcondoclub.com/api';
    // // static readonly domainNpmiLink = 'https://blue-auth.maxcondoclub.com/api';
    // // static readonly domainAmenities = 'https://amenity.maxcondoclub.com/api';
    // // static readonly domainParkingPass = 'https://parking-pass.maxcondoclub.com/api'

    // static readonly oauthClientId = '20aa5tpwg04ks4w84o8cookswwccgkwko40gwcs0ws840wkssk';
    // static readonly oauthClientSecret = '79fqd7qzbp8g8o8oggss48w4kwck4s4kccwwk8804ksowg8o';
    static readonly googleMapsApiKey = 'AIzaSyDm2NAOzOdj73eSrV-4zDxVzBhFKk11qlg';
    static readonly googleMapsApi = 'https://maps.googleapis.com/maps/api/';
    static readonly months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    static getSwalConfig(title: string, text: string = 'Are you sure you want to delete?') {
        return {
            title: title,
            text: text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            closeOnConfirm: true
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/constants.service.ts